/**
 * Formats
 * @param {Object} ctx - Context set by vuex (store)
 * @param {String} payload - Errors to be formatted
 */
export default function formatResponseErrors(errors) {
    let errorList = {};
    Object.keys(errors).forEach(function(key) {
        for (var i = 0; i < errors[key].length; i++) {
            errorList[key] = (errors[key][i]);
        }
    });

    return errorList;
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Flash/helpers/formatResponseErrors.js